import React, { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MDAvatar from "components/atoms/MDAvatar/MDAvatar";
import MenuItem from '@mui/material/MenuItem';
import { Link } from "react-router-dom";
import { useAuth } from 'hooks/useAuth';
import MDTypography from "components/atoms/MDTypography/MDTypography";
import { routesMap } from 'data/routes';
import { RouteKeys } from 'models/RouteModels';
import { useQueryClient } from 'react-query';
import ActionSlugs, { IfUserIsAllowed } from 'services/PermissionsService';
import "App.css"
import { useUserData } from 'hooks/useUserData';
import { Sizes } from 'models/StyleModels';


const UserMenu: React.FC = () => {
    const { signOut, user } = useAuth();
    const queryClient = useQueryClient();
    const { userById } = useUserData({ preventRefetch: true });

    const {
        VIEW$ORG_DETAILS_PAGE,
        VIEW$PROFILE_PAGE
    } = ActionSlugs;

    const handleSignOut = () => {
        queryClient.clear();
        signOut();
    };

    const [anchorElUser, setAnchorElUser] = useState<EventTarget & Element | null>(null);

    const handleOpenUserMenu = (event: React.MouseEvent) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (<Box sx={{ flexGrow: 0 }}>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <MDAvatar src={userById?.user.avatar_url ?? ''} size={Sizes.X_LARGE} alt="Avatar" />
        </IconButton>

        <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}>
            <MenuItem key='Email' disabled color='dull'>
                <MDTypography textAlign='center'>
                    {user?.details.email}
                </MDTypography>
            </MenuItem>
            <IfUserIsAllowed to={VIEW$PROFILE_PAGE}>
                <Link to={routesMap[RouteKeys.PROFILE].route}>
                    <MenuItem key="Profile" onClick={handleCloseUserMenu}>
                        <Typography textAlign="center">Profile</Typography>
                    </MenuItem>
                </Link>
            </IfUserIsAllowed>
            <IfUserIsAllowed to={VIEW$ORG_DETAILS_PAGE}>
                <Link to={routesMap[RouteKeys.ORG_DETAILS].route}>
                    <MenuItem key="Organization" onClick={handleCloseUserMenu}>
                        <Typography textAlign="center">Organization</Typography>
                    </MenuItem>
                </Link>
            </IfUserIsAllowed>
            <MenuItem key="Logout" onClick={handleSignOut}>
                <Typography textAlign="center">Logout</Typography>
            </MenuItem>
        </Menu>
    </Box>)
}

export default UserMenu;